import { ArrowRightOutlined } from "@ant-design/icons";
import { ArrowRightIcon } from "@chakra-ui/icons";
import { useEffect, useState } from "react";

const ActualNews = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  return (
    <div>
      <div className="white-block">
        <div>
          <h1 className="">Актуальные новости отрасли</h1>
        </div>
        <div>
          <div
            className="img-background white"
            style={{
              background: `center / contain no-repeat
              linear-gradient(360deg, rgba(49, 56, 96, 0.16) 0%, rgba(21, 25, 40, 0.88) 100%),
              url("/news-back.png")`,
            }}
          >
            <h2 className="white">
              Минпромторг объявил о поддержке предприятий
            </h2>
            <div>
              <p>
                Мантуров сообщил, что предприятия, производящие продукцию
                двойного назначения, смогут претендовать на поддержку
                государства в субсидиях.
              </p>
              <p>
                “Это будет сильный шаг в поддержке развития малого и среднего
                бизнеса в России, что позволит еще сильнее выстроить
                антисанкционную политику в стране” - сообщил Мантуров
              </p>
            </div>
            <div className="flex-end margin-top">
              <a className="white">
                Подробности <ArrowRightOutlined />
              </a>
            </div>
          </div>
          <div className="margin-top">
            <a>
              <h2>
                Ставропольский завод минводы поставит в ЮФО «Славяновскую» и
                «Нагутскую»
              </h2>
            </a>
            <div>
              ООО «Сатурн» (Ставропольский край) получило права на выпуск
              минеральной воды «Нагутская» и «Славяновская». Как сообщили РБК
              Ростов в компании, в течение нескольких месяцев предприятие
              собирается запустить производство и выйти с новой линейкой на
              южнороссийский рынок.
            </div>
            <div className="flex-end margin-top">
              <div>
                Источник: <b>kavkaz.rbc.ru</b>
              </div>
              <div className="post-statistics">
                <div className="post-statistics__item flex-simple">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.391 2.51882C11.5274 3.65525 11.5274 5.49776 10.391 6.63418C9.25459 7.77061 7.41208 7.77061 6.27566 6.63418C5.13923 5.49776 5.13923 3.65525 6.27566 2.51882C7.41208 1.3824 9.25459 1.3824 10.391 2.51882"
                      stroke="#323232"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M11.9692 10.6635C10.8867 10.231 9.61675 9.99268 8.33341 9.99268C4.96008 9.99268 1.66675 11.6318 1.66675 14.1527V14.986C1.66675 15.446 2.04008 15.8193 2.50008 15.8193H10.3442"
                      stroke="#323232"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M14.1667 18.3333C11.8658 18.3333 10 16.4683 10 14.1667C10 11.9133 11.9167 9.9975 14.17 10C16.47 10.0017 18.3333 11.8667 18.3333 14.1667C18.3333 16.4675 16.4683 18.3333 14.1667 18.3333"
                      stroke="#323232"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M12.7083 15.6252L15.6249 12.7085"
                      stroke="#323232"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M15.7572 15.5229C15.8223 15.588 15.8223 15.6936 15.7572 15.7586C15.6921 15.8237 15.5866 15.8237 15.5215 15.7586C15.4564 15.6936 15.4564 15.588 15.5215 15.5229C15.5866 15.4578 15.6921 15.4578 15.7572 15.5229"
                      stroke="#323232"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M12.8128 12.5747C12.8779 12.6398 12.8779 12.7453 12.8128 12.8104C12.7478 12.8755 12.6422 12.8755 12.5771 12.8104C12.512 12.7453 12.512 12.6398 12.5771 12.5747C12.6422 12.5096 12.7478 12.5096 12.8128 12.5747"
                      stroke="#323232"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>2%</span>
                </div>
                <div className="post-statistics__item flex-simple">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.1395 4.38444C10.9588 3.62707 12.0194 3.18284 13.1338 3.13027L13.3574 3.125C14.6276 3.125 15.8447 3.6348 16.7486 4.55354L16.9009 4.71808C18.5915 6.63193 18.5255 9.53388 16.7356 11.3732L12.2419 15.936C11.6506 16.5367 10.843 16.875 10.0002 16.875C9.15733 16.875 8.34974 16.5367 7.75859 15.9362L3.26209 11.3705C1.41285 9.47012 1.41285 6.44289 3.27646 4.52825L3.44706 4.36427C4.31979 3.56758 5.45959 3.125 6.64293 3.125C7.90329 3.125 9.11134 3.62689 10.0004 4.51891L10.1395 4.38444ZM15.8449 5.41694C15.1887 4.75037 14.2926 4.375 13.3573 4.375C12.422 4.375 11.5259 4.75037 10.8696 5.41705L10.4454 5.84782C10.2006 6.09641 9.79962 6.09641 9.55479 5.84781L9.1304 5.41687C8.4743 4.75034 7.57816 4.375 6.64289 4.375C5.77159 4.375 4.93233 4.70088 4.30195 5.27604L4.1579 5.41431C2.78087 6.82939 2.78087 9.08362 4.15528 10.496L8.64927 15.0592C9.00557 15.4211 9.49223 15.625 10.0001 15.625C10.508 15.625 10.9947 15.4211 11.3511 15.059L15.8424 10.4988C17.1732 9.13122 17.2223 6.97005 15.9742 5.55683L15.8449 5.41694Z"
                      fill="#1D1929"
                    ></path>
                  </svg>
                  <span>1</span>
                </div>
                <div className="post-statistics__item flex-simple">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M12.2033 16.59L16.75 4.32333C16.9975 3.655 16.3467 3.005 15.6792 3.2525L3.40833 7.80249C2.64083 8.08749 2.70083 9.19249 3.49499 9.39166L9.18999 10.8225L10.6125 16.5025C10.8125 17.2975 11.9183 17.3583 12.2033 16.59V16.59Z"
                      stroke="#1D1929"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M16.5583 3.44141L9.19165 10.8247"
                      stroke="#1D1929"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>0</span>
                </div>
                <div className="post-statistics__item flex-simple">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M3.45917 13.6633C2.85083 12.58 2.5 11.3317 2.5 10C2.5 5.8575 5.8575 2.5 10 2.5C14.1425 2.5 17.5 5.8575 17.5 10C17.5 14.1425 14.1425 17.5 10 17.5C8.66833 17.5 7.42 17.1492 6.33667 16.5408L2.5 17.5L3.45917 13.6633Z"
                      stroke="#1D1929"
                      stroke-width="1.3235"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>0</span>
                </div>
                <div className="post-statistics__item flex-simple">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.7684 8.23361C12.7442 9.20945 12.7442 10.7936 11.7684 11.7711C10.7926 12.7469 9.2084 12.7469 8.2309 11.7711C7.25507 10.7953 7.25507 9.21111 8.2309 8.23361C9.2084 7.25611 10.7917 7.25611 11.7684 8.23361"
                      stroke="#1D1929"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M2.5 9.99984C2.5 9.45067 2.62667 8.90734 2.87167 8.4065V8.4065C4.13417 5.82567 6.92417 4.1665 10 4.1665C13.0758 4.1665 15.8658 5.82567 17.1283 8.4065V8.4065C17.3733 8.90734 17.5 9.45067 17.5 9.99984C17.5 10.549 17.3733 11.0923 17.1283 11.5932V11.5932C15.8658 14.174 13.0758 15.8332 10 15.8332C6.92417 15.8332 4.13417 14.174 2.87167 11.5932V11.5932C2.62667 11.0923 2.5 10.549 2.5 9.99984Z"
                      stroke="#1D1929"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>64</span>
                </div>
                <div className="post-statistics__item flex-simple">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.66675 15.8333C1.66675 14 3.16675 12.5 5.00008 12.5H8.33341C10.1667 12.5 11.6667 14 11.6667 15.8333"
                      stroke="#1D1929"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M8.74998 5.00029C9.91665 6.16696 9.91665 8.00029 8.74998 9.08362C7.58331 10.167 5.74998 10.2503 4.66665 9.08362C3.58331 7.91696 3.49998 6.16696 4.58331 5.00029C5.66665 3.83362 7.58331 3.91696 8.74998 5.00029"
                      stroke="#1D1929"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M13.3333 11.6665H15.8333C17.2499 11.6665 18.3333 12.7498 18.3333 14.1665"
                      stroke="#1D1929"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M16.0833 5.5835C16.9167 6.41683 16.9167 7.75016 16.0833 8.50016C15.25 9.25016 13.9167 9.3335 13.1667 8.50016C12.4167 7.66683 12.3333 6.3335 13.1667 5.5835C13.9167 4.8335 15.25 4.8335 16.0833 5.5835"
                      stroke="#1D1929"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>635</span>
                </div>
              </div>
            </div>
          </div>
          <div className="margin-top">
            <a>
              <h2>
                Ставропольский завод минводы поставит в ЮФО «Славяновскую» и
                «Нагутскую»
              </h2>
            </a>
            <div>
              ООО «Сатурн» (Ставропольский край) получило права на выпуск
              минеральной воды «Нагутская» и «Славяновская». Как сообщили РБК
              Ростов в компании, в течение нескольких месяцев предприятие
              собирается запустить производство и выйти с новой линейкой на
              южнороссийский рынок.
            </div>
            <div className="flex-end margin-top">
              <div>
                Источник: <b>kavkaz.rbc.ru</b>
              </div>
              <div className="post-statistics">
                <div className="post-statistics__item flex-simple">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.391 2.51882C11.5274 3.65525 11.5274 5.49776 10.391 6.63418C9.25459 7.77061 7.41208 7.77061 6.27566 6.63418C5.13923 5.49776 5.13923 3.65525 6.27566 2.51882C7.41208 1.3824 9.25459 1.3824 10.391 2.51882"
                      stroke="#323232"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M11.9692 10.6635C10.8867 10.231 9.61675 9.99268 8.33341 9.99268C4.96008 9.99268 1.66675 11.6318 1.66675 14.1527V14.986C1.66675 15.446 2.04008 15.8193 2.50008 15.8193H10.3442"
                      stroke="#323232"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M14.1667 18.3333C11.8658 18.3333 10 16.4683 10 14.1667C10 11.9133 11.9167 9.9975 14.17 10C16.47 10.0017 18.3333 11.8667 18.3333 14.1667C18.3333 16.4675 16.4683 18.3333 14.1667 18.3333"
                      stroke="#323232"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M12.7083 15.6252L15.6249 12.7085"
                      stroke="#323232"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M15.7572 15.5229C15.8223 15.588 15.8223 15.6936 15.7572 15.7586C15.6921 15.8237 15.5866 15.8237 15.5215 15.7586C15.4564 15.6936 15.4564 15.588 15.5215 15.5229C15.5866 15.4578 15.6921 15.4578 15.7572 15.5229"
                      stroke="#323232"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M12.8128 12.5747C12.8779 12.6398 12.8779 12.7453 12.8128 12.8104C12.7478 12.8755 12.6422 12.8755 12.5771 12.8104C12.512 12.7453 12.512 12.6398 12.5771 12.5747C12.6422 12.5096 12.7478 12.5096 12.8128 12.5747"
                      stroke="#323232"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>2%</span>
                </div>
                <div className="post-statistics__item flex-simple">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.1395 4.38444C10.9588 3.62707 12.0194 3.18284 13.1338 3.13027L13.3574 3.125C14.6276 3.125 15.8447 3.6348 16.7486 4.55354L16.9009 4.71808C18.5915 6.63193 18.5255 9.53388 16.7356 11.3732L12.2419 15.936C11.6506 16.5367 10.843 16.875 10.0002 16.875C9.15733 16.875 8.34974 16.5367 7.75859 15.9362L3.26209 11.3705C1.41285 9.47012 1.41285 6.44289 3.27646 4.52825L3.44706 4.36427C4.31979 3.56758 5.45959 3.125 6.64293 3.125C7.90329 3.125 9.11134 3.62689 10.0004 4.51891L10.1395 4.38444ZM15.8449 5.41694C15.1887 4.75037 14.2926 4.375 13.3573 4.375C12.422 4.375 11.5259 4.75037 10.8696 5.41705L10.4454 5.84782C10.2006 6.09641 9.79962 6.09641 9.55479 5.84781L9.1304 5.41687C8.4743 4.75034 7.57816 4.375 6.64289 4.375C5.77159 4.375 4.93233 4.70088 4.30195 5.27604L4.1579 5.41431C2.78087 6.82939 2.78087 9.08362 4.15528 10.496L8.64927 15.0592C9.00557 15.4211 9.49223 15.625 10.0001 15.625C10.508 15.625 10.9947 15.4211 11.3511 15.059L15.8424 10.4988C17.1732 9.13122 17.2223 6.97005 15.9742 5.55683L15.8449 5.41694Z"
                      fill="#1D1929"
                    ></path>
                  </svg>
                  <span>1</span>
                </div>
                <div className="post-statistics__item flex-simple">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M12.2033 16.59L16.75 4.32333C16.9975 3.655 16.3467 3.005 15.6792 3.2525L3.40833 7.80249C2.64083 8.08749 2.70083 9.19249 3.49499 9.39166L9.18999 10.8225L10.6125 16.5025C10.8125 17.2975 11.9183 17.3583 12.2033 16.59V16.59Z"
                      stroke="#1D1929"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M16.5583 3.44141L9.19165 10.8247"
                      stroke="#1D1929"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>0</span>
                </div>
                <div className="post-statistics__item flex-simple">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M3.45917 13.6633C2.85083 12.58 2.5 11.3317 2.5 10C2.5 5.8575 5.8575 2.5 10 2.5C14.1425 2.5 17.5 5.8575 17.5 10C17.5 14.1425 14.1425 17.5 10 17.5C8.66833 17.5 7.42 17.1492 6.33667 16.5408L2.5 17.5L3.45917 13.6633Z"
                      stroke="#1D1929"
                      stroke-width="1.3235"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>0</span>
                </div>
                <div className="post-statistics__item flex-simple">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.7684 8.23361C12.7442 9.20945 12.7442 10.7936 11.7684 11.7711C10.7926 12.7469 9.2084 12.7469 8.2309 11.7711C7.25507 10.7953 7.25507 9.21111 8.2309 8.23361C9.2084 7.25611 10.7917 7.25611 11.7684 8.23361"
                      stroke="#1D1929"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M2.5 9.99984C2.5 9.45067 2.62667 8.90734 2.87167 8.4065V8.4065C4.13417 5.82567 6.92417 4.1665 10 4.1665C13.0758 4.1665 15.8658 5.82567 17.1283 8.4065V8.4065C17.3733 8.90734 17.5 9.45067 17.5 9.99984C17.5 10.549 17.3733 11.0923 17.1283 11.5932V11.5932C15.8658 14.174 13.0758 15.8332 10 15.8332C6.92417 15.8332 4.13417 14.174 2.87167 11.5932V11.5932C2.62667 11.0923 2.5 10.549 2.5 9.99984Z"
                      stroke="#1D1929"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>64</span>
                </div>
                <div className="post-statistics__item flex-simple">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.66675 15.8333C1.66675 14 3.16675 12.5 5.00008 12.5H8.33341C10.1667 12.5 11.6667 14 11.6667 15.8333"
                      stroke="#1D1929"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M8.74998 5.00029C9.91665 6.16696 9.91665 8.00029 8.74998 9.08362C7.58331 10.167 5.74998 10.2503 4.66665 9.08362C3.58331 7.91696 3.49998 6.16696 4.58331 5.00029C5.66665 3.83362 7.58331 3.91696 8.74998 5.00029"
                      stroke="#1D1929"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M13.3333 11.6665H15.8333C17.2499 11.6665 18.3333 12.7498 18.3333 14.1665"
                      stroke="#1D1929"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M16.0833 5.5835C16.9167 6.41683 16.9167 7.75016 16.0833 8.50016C15.25 9.25016 13.9167 9.3335 13.1667 8.50016C12.4167 7.66683 12.3333 6.3335 13.1667 5.5835C13.9167 4.8335 15.25 4.8335 16.0833 5.5835"
                      stroke="#1D1929"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>635</span>
                </div>
              </div>
            </div>
          </div>
          <div className="margin-top">
            <a>
              <h2>
                Ставропольский завод минводы поставит в ЮФО «Славяновскую» и
                «Нагутскую»
              </h2>
            </a>
            <div>
              ООО «Сатурн» (Ставропольский край) получило права на выпуск
              минеральной воды «Нагутская» и «Славяновская». Как сообщили РБК
              Ростов в компании, в течение нескольких месяцев предприятие
              собирается запустить производство и выйти с новой линейкой на
              южнороссийский рынок.
            </div>
            <div className="flex-end margin-top">
              <div>
                Источник:{" "}
                <a>
                  <b>kavkaz.rbc.ru</b>
                </a>
              </div>
              <div className="post-statistics">
                <div className="post-statistics__item flex-simple">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.391 2.51882C11.5274 3.65525 11.5274 5.49776 10.391 6.63418C9.25459 7.77061 7.41208 7.77061 6.27566 6.63418C5.13923 5.49776 5.13923 3.65525 6.27566 2.51882C7.41208 1.3824 9.25459 1.3824 10.391 2.51882"
                      stroke="#323232"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M11.9692 10.6635C10.8867 10.231 9.61675 9.99268 8.33341 9.99268C4.96008 9.99268 1.66675 11.6318 1.66675 14.1527V14.986C1.66675 15.446 2.04008 15.8193 2.50008 15.8193H10.3442"
                      stroke="#323232"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M14.1667 18.3333C11.8658 18.3333 10 16.4683 10 14.1667C10 11.9133 11.9167 9.9975 14.17 10C16.47 10.0017 18.3333 11.8667 18.3333 14.1667C18.3333 16.4675 16.4683 18.3333 14.1667 18.3333"
                      stroke="#323232"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M12.7083 15.6252L15.6249 12.7085"
                      stroke="#323232"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M15.7572 15.5229C15.8223 15.588 15.8223 15.6936 15.7572 15.7586C15.6921 15.8237 15.5866 15.8237 15.5215 15.7586C15.4564 15.6936 15.4564 15.588 15.5215 15.5229C15.5866 15.4578 15.6921 15.4578 15.7572 15.5229"
                      stroke="#323232"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M12.8128 12.5747C12.8779 12.6398 12.8779 12.7453 12.8128 12.8104C12.7478 12.8755 12.6422 12.8755 12.5771 12.8104C12.512 12.7453 12.512 12.6398 12.5771 12.5747C12.6422 12.5096 12.7478 12.5096 12.8128 12.5747"
                      stroke="#323232"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>2%</span>
                </div>
                <div className="post-statistics__item flex-simple">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.1395 4.38444C10.9588 3.62707 12.0194 3.18284 13.1338 3.13027L13.3574 3.125C14.6276 3.125 15.8447 3.6348 16.7486 4.55354L16.9009 4.71808C18.5915 6.63193 18.5255 9.53388 16.7356 11.3732L12.2419 15.936C11.6506 16.5367 10.843 16.875 10.0002 16.875C9.15733 16.875 8.34974 16.5367 7.75859 15.9362L3.26209 11.3705C1.41285 9.47012 1.41285 6.44289 3.27646 4.52825L3.44706 4.36427C4.31979 3.56758 5.45959 3.125 6.64293 3.125C7.90329 3.125 9.11134 3.62689 10.0004 4.51891L10.1395 4.38444ZM15.8449 5.41694C15.1887 4.75037 14.2926 4.375 13.3573 4.375C12.422 4.375 11.5259 4.75037 10.8696 5.41705L10.4454 5.84782C10.2006 6.09641 9.79962 6.09641 9.55479 5.84781L9.1304 5.41687C8.4743 4.75034 7.57816 4.375 6.64289 4.375C5.77159 4.375 4.93233 4.70088 4.30195 5.27604L4.1579 5.41431C2.78087 6.82939 2.78087 9.08362 4.15528 10.496L8.64927 15.0592C9.00557 15.4211 9.49223 15.625 10.0001 15.625C10.508 15.625 10.9947 15.4211 11.3511 15.059L15.8424 10.4988C17.1732 9.13122 17.2223 6.97005 15.9742 5.55683L15.8449 5.41694Z"
                      fill="#1D1929"
                    ></path>
                  </svg>
                  <span>1</span>
                </div>
                <div className="post-statistics__item flex-simple">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M12.2033 16.59L16.75 4.32333C16.9975 3.655 16.3467 3.005 15.6792 3.2525L3.40833 7.80249C2.64083 8.08749 2.70083 9.19249 3.49499 9.39166L9.18999 10.8225L10.6125 16.5025C10.8125 17.2975 11.9183 17.3583 12.2033 16.59V16.59Z"
                      stroke="#1D1929"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M16.5583 3.44141L9.19165 10.8247"
                      stroke="#1D1929"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>0</span>
                </div>
                <div className="post-statistics__item flex-simple">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M3.45917 13.6633C2.85083 12.58 2.5 11.3317 2.5 10C2.5 5.8575 5.8575 2.5 10 2.5C14.1425 2.5 17.5 5.8575 17.5 10C17.5 14.1425 14.1425 17.5 10 17.5C8.66833 17.5 7.42 17.1492 6.33667 16.5408L2.5 17.5L3.45917 13.6633Z"
                      stroke="#1D1929"
                      stroke-width="1.3235"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>0</span>
                </div>
                <div className="post-statistics__item flex-simple">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.7684 8.23361C12.7442 9.20945 12.7442 10.7936 11.7684 11.7711C10.7926 12.7469 9.2084 12.7469 8.2309 11.7711C7.25507 10.7953 7.25507 9.21111 8.2309 8.23361C9.2084 7.25611 10.7917 7.25611 11.7684 8.23361"
                      stroke="#1D1929"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M2.5 9.99984C2.5 9.45067 2.62667 8.90734 2.87167 8.4065V8.4065C4.13417 5.82567 6.92417 4.1665 10 4.1665C13.0758 4.1665 15.8658 5.82567 17.1283 8.4065V8.4065C17.3733 8.90734 17.5 9.45067 17.5 9.99984C17.5 10.549 17.3733 11.0923 17.1283 11.5932V11.5932C15.8658 14.174 13.0758 15.8332 10 15.8332C6.92417 15.8332 4.13417 14.174 2.87167 11.5932V11.5932C2.62667 11.0923 2.5 10.549 2.5 9.99984Z"
                      stroke="#1D1929"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>64</span>
                </div>
                <div className="post-statistics__item flex-simple">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.66675 15.8333C1.66675 14 3.16675 12.5 5.00008 12.5H8.33341C10.1667 12.5 11.6667 14 11.6667 15.8333"
                      stroke="#1D1929"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M8.74998 5.00029C9.91665 6.16696 9.91665 8.00029 8.74998 9.08362C7.58331 10.167 5.74998 10.2503 4.66665 9.08362C3.58331 7.91696 3.49998 6.16696 4.58331 5.00029C5.66665 3.83362 7.58331 3.91696 8.74998 5.00029"
                      stroke="#1D1929"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M13.3333 11.6665H15.8333C17.2499 11.6665 18.3333 12.7498 18.3333 14.1665"
                      stroke="#1D1929"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M16.0833 5.5835C16.9167 6.41683 16.9167 7.75016 16.0833 8.50016C15.25 9.25016 13.9167 9.3335 13.1667 8.50016C12.4167 7.66683 12.3333 6.3335 13.1667 5.5835C13.9167 4.8335 15.25 4.8335 16.0833 5.5835"
                      stroke="#1D1929"
                      stroke-width="1.25"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  <span>635</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ActualNews;
